export default __webpack_public_path__ + "static/media/about-me.3fe26464.png";